import React from 'react';
import PropTypes from 'prop-types';

// Components
import AppBarError from '../components/Layout/Error/AppBar';
import FooterError from '../components/Layout/Error/Footer';

export default function ErrorLayout({ children }) {
  return (
    <>
      <AppBarError />
      <main role="main" itemProp="mainContentOfPage">
        {children}
      </main>
      <FooterError />
    </>
  );
}

// Prop Types
ErrorLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
